import { default as _91id_93Ps80l7QQYDMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/crawlerrors/[id].vue?macro=true";
import { default as indexFTHiwmIePVMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/crawlerrors/index.vue?macro=true";
import { default as loginCvVUhReuLAMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/credentials/[id]/login.vue?macro=true";
import { default as indexu8nodAKAf2Meta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/credentials/index.vue?macro=true";
import { default as customerscV7mbX30T3Meta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/customers.vue?macro=true";
import { default as index5s7aFFLoFaMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/index.vue?macro=true";
import { default as itemsuHG5qV4zF1Meta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/items.vue?macro=true";
import { default as loginW5hnJq4kaGMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/login.vue?macro=true";
import { default as sources_45reviewMk32qJ9kF9Meta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/sources-review.vue?macro=true";
import { default as _91channel_93LR7cnC6giGMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/sources/[channel].vue?macro=true";
import { default as indexFiinjg2d3pMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/tasks/index.vue?macro=true";
import { default as index7u9ugC9LAoMeta } from "/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/topics/index.vue?macro=true";
export default [
  {
    name: _91id_93Ps80l7QQYDMeta?.name ?? "crawlerrors-id",
    path: _91id_93Ps80l7QQYDMeta?.path ?? "/crawlerrors/:id()",
    meta: _91id_93Ps80l7QQYDMeta || {},
    alias: _91id_93Ps80l7QQYDMeta?.alias || [],
    redirect: _91id_93Ps80l7QQYDMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/crawlerrors/[id].vue").then(m => m.default || m)
  },
  {
    name: indexFTHiwmIePVMeta?.name ?? "crawlerrors",
    path: indexFTHiwmIePVMeta?.path ?? "/crawlerrors",
    meta: indexFTHiwmIePVMeta || {},
    alias: indexFTHiwmIePVMeta?.alias || [],
    redirect: indexFTHiwmIePVMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/crawlerrors/index.vue").then(m => m.default || m)
  },
  {
    name: loginCvVUhReuLAMeta?.name ?? "credentials-id-login",
    path: loginCvVUhReuLAMeta?.path ?? "/credentials/:id()/login",
    meta: loginCvVUhReuLAMeta || {},
    alias: loginCvVUhReuLAMeta?.alias || [],
    redirect: loginCvVUhReuLAMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/credentials/[id]/login.vue").then(m => m.default || m)
  },
  {
    name: indexu8nodAKAf2Meta?.name ?? "credentials",
    path: indexu8nodAKAf2Meta?.path ?? "/credentials",
    meta: indexu8nodAKAf2Meta || {},
    alias: indexu8nodAKAf2Meta?.alias || [],
    redirect: indexu8nodAKAf2Meta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/credentials/index.vue").then(m => m.default || m)
  },
  {
    name: customerscV7mbX30T3Meta?.name ?? "customers",
    path: customerscV7mbX30T3Meta?.path ?? "/customers",
    meta: customerscV7mbX30T3Meta || {},
    alias: customerscV7mbX30T3Meta?.alias || [],
    redirect: customerscV7mbX30T3Meta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/customers.vue").then(m => m.default || m)
  },
  {
    name: index5s7aFFLoFaMeta?.name ?? "index",
    path: index5s7aFFLoFaMeta?.path ?? "/",
    meta: index5s7aFFLoFaMeta || {},
    alias: index5s7aFFLoFaMeta?.alias || [],
    redirect: index5s7aFFLoFaMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: itemsuHG5qV4zF1Meta?.name ?? "items",
    path: itemsuHG5qV4zF1Meta?.path ?? "/items",
    meta: itemsuHG5qV4zF1Meta || {},
    alias: itemsuHG5qV4zF1Meta?.alias || [],
    redirect: itemsuHG5qV4zF1Meta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/items.vue").then(m => m.default || m)
  },
  {
    name: loginW5hnJq4kaGMeta?.name ?? "login",
    path: loginW5hnJq4kaGMeta?.path ?? "/login",
    meta: loginW5hnJq4kaGMeta || {},
    alias: loginW5hnJq4kaGMeta?.alias || [],
    redirect: loginW5hnJq4kaGMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: sources_45reviewMk32qJ9kF9Meta?.name ?? "sources-review",
    path: sources_45reviewMk32qJ9kF9Meta?.path ?? "/sources-review",
    meta: sources_45reviewMk32qJ9kF9Meta || {},
    alias: sources_45reviewMk32qJ9kF9Meta?.alias || [],
    redirect: sources_45reviewMk32qJ9kF9Meta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/sources-review.vue").then(m => m.default || m)
  },
  {
    name: _91channel_93LR7cnC6giGMeta?.name ?? "sources-channel",
    path: _91channel_93LR7cnC6giGMeta?.path ?? "/sources/:channel()",
    meta: _91channel_93LR7cnC6giGMeta || {},
    alias: _91channel_93LR7cnC6giGMeta?.alias || [],
    redirect: _91channel_93LR7cnC6giGMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/sources/[channel].vue").then(m => m.default || m)
  },
  {
    name: indexFiinjg2d3pMeta?.name ?? "tasks",
    path: indexFiinjg2d3pMeta?.path ?? "/tasks",
    meta: indexFiinjg2d3pMeta || {},
    alias: indexFiinjg2d3pMeta?.alias || [],
    redirect: indexFiinjg2d3pMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/tasks/index.vue").then(m => m.default || m)
  },
  {
    name: index7u9ugC9LAoMeta?.name ?? "topics",
    path: index7u9ugC9LAoMeta?.path ?? "/topics",
    meta: index7u9ugC9LAoMeta || {},
    alias: index7u9ugC9LAoMeta?.alias || [],
    redirect: index7u9ugC9LAoMeta?.redirect || undefined,
    component: () => import("/builds/bolorsoft/edukudo/eduge-input-man/frontend/pages/topics/index.vue").then(m => m.default || m)
  }
]